import { fileCollectionFromWebSource } from 'filelist-utils';
import { CURRENT_EXPORT_VERSION } from '../migration/MigrationManager';
import { generalFiltering } from '../utilities/generalFiltering';
import { removeDotBeginningOfPath } from '../utilities/removeDotBeginningOfPath';
import { process } from './read';
import { readBruker } from './readBruker';
/**
 * from an array of { name, relativePath }, it tries to fetch data
 * to generate a nmriumState structure and add the respective filter for each spectrum added.
 */
export async function readFromWebSource(source, options = {}) {
    const { keepSource = true } = options;
    let result = {
        version: CURRENT_EXPORT_VERSION,
        data: {
            source,
            spectra: [],
            molecules: [],
        },
    };
    const data = result.data;
    if (!data)
        throw new Error('data should exists');
    const fileCollection = await fileCollectionFromWebSource({
        ...source,
        entries: removeDotBeginningOfPath(source.entries),
    });
    const { sourceSelector, converter } = options;
    const brukerResult = await readBruker(fileCollection, {
        selector: sourceSelector,
        keepSource,
        converter: { keepFiles: true, ...converter?.bruker },
    });
    data.spectra.push(...brukerResult.spectra);
    for (let file of fileCollection) {
        const { spectra = [], molecules = [] } = await process(file, {
            ...options,
            keepSource,
        });
        data.spectra.push(...spectra);
        data.molecules.push(...molecules);
    }
    const { general: generalFilter } = options.sourceSelector || {};
    return generalFiltering(result, generalFilter);
}
//# sourceMappingURL=readFromWebSource.js.map